import Joi from 'joi'
import language from './language'

export default Joi.object().keys({
    password: Joi.string().min(1).max(100).required().options({ language })
})